var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 32.4243,
    height: 32.4243,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3811 9.42414L18.2883 2.33132C18.0857 2.12867 17.883 2.02734 17.579 2.02734H7.44644C6.33186 2.02734 5.41992 2.93928 5.41992 4.05386V28.3721C5.41992 29.4867 6.33186 30.3986 7.44644 30.3986H23.6586C24.7732 30.3986 25.6851 29.4867 25.6851 28.3721V10.1334C25.6851 9.82944 25.5838 9.62679 25.3811 9.42414ZM17.579 4.45917L23.2533 10.1334H17.579V4.45917ZM23.6586 28.3721H7.44644V4.05386H15.5525V10.1334C15.5525 11.248 16.4645 12.1599 17.579 12.1599H23.6586V28.3721Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5814 14.4175L15.4027 18.2388L19.2239 14.4175L20.6569 15.8505L16.8356 19.6718L20.6569 23.493L19.2239 24.926L15.4027 21.1047L11.5814 24.926L10.1485 23.493L13.9697 19.6718L10.1485 15.8505L11.5814 14.4175Z",
    fill: "#FF5326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileError);
export default __webpack_public_path__ + "static/media/icon_FileError.34764f5207f26c6ed72725756e997365.svg";
export { ForwardRef as ReactComponent };